import ModernProductCardSkeleton from "@modules/products/components/modern-product-card-skeleton"

const SkeletonProductPreview = () => {
  return <ModernProductCardSkeleton />
}

export default SkeletonProductPreview
